import {
    IPopupProps,
    PopupAnchor,
    PopupId,
    PopupKind,
    PopupSize,
    PopupSource,
    SourceAnchor,
} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {ReactElement} from 'react';

export class PopupItemWithIndex
{
    constructor(public stackIndex:number,
                public popupItem:PopupItem)
    {
    }
}

export class PopupItem
{
    public popupSource:PopupSource;
    public forceHandler:() => void;

    constructor(public id:PopupId,
                public kind:PopupKind,
                public specProps:IPopupProps,
                public viewElement:ReactElement<any>,
                public sourceAnchor:SourceAnchor,
                public popupAnchor:PopupAnchor,
                public popupSize:PopupSize,
                public ignoreEsc:boolean = false,
    )
    {
    }

    public forceViewRefresh():void
    {
        if( this.forceHandler )
            this.forceHandler();
    }
}
